// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2BDl_","signatureButtonsRight":"ModalSign_signatureButtonsRight__2qrQe"};